module.exports = __webpack_public_path__ + "static/media/educational.713db7b4.png";